
export default {
  name: 'EventSubscribeModal',
  props: {
    eventId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    loading: false
  }),
  methods: {
    close() {
      this.$emit('close')
    },
    async submit(data) {
      this.loading = true
      try {
        const { email, name: client_name } = data
        await this.$axios.post(`/api/event/${this.eventId}/subscribe`, {
          email,
          client_name
        })

        this.$notify({
          type: 'success',
          group: 'ts',
          title: this.$t('headings.success')
        })

        this.close()
      } catch (e) {
      } finally {
        this.loading = false
      }
    }
  }
}
